import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  TimeScale,
} from 'chart.js';
import 'chartjs-adapter-date-fns';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend, TimeScale);

function WeatherChart({ data }) {
  if (!data || data.length === 0) return null;

  const chartData = {
    datasets: [
      {
        label: 'Air Temp (°F)',
        data: data.map(d => ({ x: d.time, y: d.temp })),
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'transparent',
        tension: 0.4,
        pointRadius: 0,
        yAxisID: 'yTemp',
      },
      {
        label: 'Precip (%)',
        data: data.map(d => ({ x: d.time, y: d.precip })),
        borderColor: 'rgb(54, 162, 235)',
        backgroundColor: 'transparent',
        tension: 0.4,
        pointRadius: 0,
        yAxisID: 'yRight',
      },
      {
        label: 'Wind (mph)',
        data: data.map(d => ({ x: d.time, y: d.wind })),
        borderColor: 'rgb(75, 192, 192)',
        backgroundColor: 'transparent',
        tension: 0.4,
        pointRadius: 0,
        yAxisID: 'yRight',
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    interaction: { mode: 'index', intersect: false },
    plugins: {
      legend: {
        position: 'bottom',
        labels: { boxWidth: 10, font: { size: 10 }, padding: 8 },
      },
      tooltip: {
        callbacks: {
          title: (items) => new Date(items[0].parsed.x).toLocaleString([], {
            weekday: 'short', hour: '2-digit', minute: '2-digit',
          }),
        },
      },
    },
    scales: {
      x: {
        type: 'time',
        time: { displayFormats: { hour: 'ha' } },
        ticks: { maxTicksLimit: 6, font: { size: 9 } },
        grid: { display: false },
      },
      yTemp: {
        position: 'left',
        title: { display: true, text: '°F', font: { size: 9 } },
        ticks: { font: { size: 9 }, maxTicksLimit: 5 },
      },
      yRight: {
        position: 'right',
        min: 0,
        max: 100,
        title: { display: true, text: '% / mph', font: { size: 9 } },
        ticks: { font: { size: 9 }, maxTicksLimit: 5 },
        grid: { drawOnChartArea: false },
      },
    },
  };

  return (
    <div style={{ height: '160px' }}>
      <Line data={chartData} options={options} />
    </div>
  );
}

export default WeatherChart;
